import React from 'react';
import styles from './GearCardSkeleton.module.css';

function GearCardSkeleton() {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.imagePlaceholder}>
        <div className={styles.shimmer}></div>
      </div>
      <div className={styles.textLine} style={{ width: '80%', height: '1.2rem' }}>
        <div className={styles.shimmer}></div>
      </div>
      <div className={styles.textLine} style={{ width: '60%' }}>
        <div className={styles.shimmer}></div>
      </div>
      <div className={styles.textLine} style={{ width: '40%' }}>
        <div className={styles.shimmer}></div>
      </div>
    </div>
  );
}

export default GearCardSkeleton;
